import { render, staticRenderFns } from "./ExcelData.vue?vue&type=template&id=3b8c6e89&scoped=true"
import script from "./ExcelData.vue?vue&type=script&lang=js"
export * from "./ExcelData.vue?vue&type=script&lang=js"
import style0 from "./ExcelData.vue?vue&type=style&index=0&id=3b8c6e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c6e89",
  null
  
)

export default component.exports